import { render, staticRenderFns } from "./professions-reglementees-guide-des-bonnes-pratiques-pour-communiquer-sur-internet.vue?vue&type=template&id=5dfd81db&"
import script from "./professions-reglementees-guide-des-bonnes-pratiques-pour-communiquer-sur-internet.vue?vue&type=script&lang=js&"
export * from "./professions-reglementees-guide-des-bonnes-pratiques-pour-communiquer-sur-internet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports